import { render, staticRenderFns } from "./SquaredLogoField.vue?vue&type=template&id=849cf584&"
import script from "./SquaredLogoField.vue?vue&type=script&lang=js&"
export * from "./SquaredLogoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports